/**
 * Normalize a law firm name for exact-duplicate comparison (aligned with backend).
 */
export function normalizeLawFirmName(name) {
  if (!name) return "";
  let s = String(name).trim().toLowerCase();
  s = s.replace(/\s+/g, " ");
  s = s.replace(/[^\w\s&]+/g, "");
  return s;
}

export function isExactLawFirmNameMatch(nameA, nameB) {
  const a = normalizeLawFirmName(nameA);
  const b = normalizeLawFirmName(nameB);
  return a !== "" && a === b;
}
